import styled from "styled-components";

export const Content = styled.div`
  margin: 66px 33px 0px 33px;
`;

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  min-height: 80vh;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

/** Header (linha superior com Olá, Ayrton! e a notificação) */
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: linear-gradient(
    269.86deg,
    rgba(6, 217, 134, 0.3) 0%,
    rgba(74, 118, 251, 0.3) 100%
  );
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

/** Título "Olá, Ayrton!" */
export const WelcomeTitle = styled.h1`
  display: flex;
  font-family: Inter;
  font-weight: 400;
  font-size: 22px;
  line-height: 27.4px;
  letter-spacing: -0.23px;
`;

/** Contêiner que agrupa o badge e o "avatar" */
export const NotificationWrapper = styled.div`
  position: relative;
`;

/** Badge de notificação (bolinha vermelha) */
export const NotificationBadge = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  background-color: #ef4444; /* Tailwind "bg-red-500" */
  color: #ffffff;
  font-size: 0.75rem; /* Tailwind "text-xs" */
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** "Avatar" cinza (fake) */
export const UserAvatar = styled.div`
  width: 32px; /* Tailwind "w-8" */
  height: 32px; /* Tailwind "h-8" */
  border-radius: 9999px;
  background-color: #e5e7eb; /* Tailwind "bg-gray-200" */
`;

export const Title = styled.h1`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 29.05px;
  letter-spacing: -1%;
  background: linear-gradient(to right, #1f2937, #4b5563);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const AnimationsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
